<div>

</div>

<script>
import { Bar } from 'vue-chartjs'

export default {
  extends: Bar,
  components: { Bar },
  props: ['data'],

  methods: {
    renderBarChart () {
      this.renderChart({
        labels: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday', 'This Week'],
        datasets: [
          {
            label: 'Me',
            backgroundColor: '#4472c4',
            data: this.data,
            barPercentage: 0.5
          }
        ]
      },

      {
        tooltips: {
          enabled: false
        },
        scales: {
          yAxes: [{
            display: false,
            ticks: {
              beginAtZero: true
            }
          }]
        },
        responsive: true,
        maintainAspectRatio: false,
        hover: {
          animationDuration: 1
        },
        animation: {
          onComplete: function () {
            const chartInstance = this.chart
            const ctx = chartInstance.ctx
            ctx.textAlign = 'center'
            ctx.fillStyle = 'rgba(0, 0, 0, 1)'
            ctx.textBaseline = 'bottom'

            this.data.datasets.forEach(function (dataset, i) {
              const meta = chartInstance.controller.getDatasetMeta(i)
              meta.data.forEach(function (bar, index) {
                const data = dataset.data[index]
                ctx.fillText(data, bar._model.x, bar._model.y - 5)
              })
            })
          }
        }
      })
    }
  },

  mounted () {
    this.renderBarChart()
  }
}
</script>
<style scoped>
    canvas {
        width: 350px;
    }
</style>
